"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _PaginationButton = _interopRequireDefault(require("./PaginationButton"));
var _PaginationItem = _interopRequireDefault(require("./PaginationItem"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const scrollTop = () => window.scrollTo(0, 0);
const generatePaginationItems = (pageNumbers, currentPage, truncateThreshold, changePage) => {
  const lastPage = pageNumbers.length;
  const truncated = lastPage > truncateThreshold;
  let visiblePages;
  if (truncated) {
    // the default range for pages outside the start and end threshold
    let start = currentPage - 2;
    let end = currentPage + 1;
    // on page 1, also show pages 2, 3 and 4
    if (currentPage === 1) {
      start = 1;
      end = Math.min(lastPage - 1, currentPage + 3);
    }
    // on page 2, show page 1, and also pages 3, and 4
    if (currentPage === 2) {
      start = 1;
      end = Math.min(lastPage - 1, currentPage + 3);
    }
    // on the last page and page before last, also show the 3 previous pages
    if (currentPage === lastPage || currentPage === lastPage - 1) {
      start = Math.max(1, lastPage - 4);
      end = lastPage - 1;
    }
    visiblePages = pageNumbers.slice(start, end);
  } else {
    visiblePages = pageNumbers;
  }
  const items = [];
  if (truncated) {
    // render first in sequence
    items.push( /*#__PURE__*/_react.default.createElement(_PaginationItem.default, {
      key: 1,
      number: 1,
      isActive: currentPage === 1,
      onClick: () => changePage(1)
    }));
    if (!visiblePages.includes(2)) {
      items.push( /*#__PURE__*/_react.default.createElement(PaginationItemSeparator, {
        key: "sep1"
      }));
    }
  }
  items.push(visiblePages.map(number => /*#__PURE__*/_react.default.createElement(_PaginationItem.default, {
    key: number,
    number: number,
    isActive: number === currentPage,
    onClick: () => changePage(number)
  })));
  if (truncated) {
    // render last in sequence
    if (!visiblePages.includes(lastPage - 1)) {
      items.push( /*#__PURE__*/_react.default.createElement(PaginationItemSeparator, {
        key: "sep2"
      }));
    }
    items.push( /*#__PURE__*/_react.default.createElement(_PaginationItem.default, {
      key: lastPage,
      number: lastPage,
      isActive: currentPage === lastPage,
      onClick: () => changePage(lastPage)
    }));
  }
  return items;
};
const PaginationItemSeparator = () => /*#__PURE__*/_react.default.createElement("li", {
  className: "p-pagination__item p-pagination__item--truncation"
}, "\u2026");

// Props that are used in both types of paginations.

// Used when number of items per page, number of total items,
// current page and paginate function is defined. Pagination
// is handled by paginate function and optional onForward and
// onBack functions.

// Used when number of items per page, number of total items,
// current page and paginate function are undefined.
// Pagination is handled by onForward and onBack function.

/**
This is a [React](https://reactjs.org/) component for the Vanilla [Pagination](https://docs.vanillaframework.io/patterns/pagination/).

The pagination component should be used to navigate between pages of content. There are two types of pagination being provided:

* **Numbered Pagination:** used when the total number of items is known.<br />
  Depending on the length provided, the pagination component will automatically scale.<br />
  **Required props:** itemsPerPage, totalItems, paginate, currentPage.

* **Buttons-only Pagination:** used when the total number of items is unknown.<br />
  **Required props:** onForward, onBack.
 */
const Pagination = _ref => {
  let {
    itemsPerPage,
    totalItems,
    paginate,
    currentPage,
    scrollToTop,
    truncateThreshold = 10,
    centered,
    showLabels,
    hideNumbers,
    onForward,
    onBack,
    forwardDisabled,
    backDisabled,
    forwardLabel,
    backLabel,
    ...navProps
  } = _ref;
  const isNumberedPagination = !!itemsPerPage && !!totalItems && !!currentPage && !!paginate;
  const pageNumbers = [];
  if (isNumberedPagination) {
    // return early if no pagination is required
    if (totalItems <= itemsPerPage) {
      return null;
    }
    for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
      pageNumbers.push(i);
    }
  }
  const changeNumberedPage = page => {
    paginate(page);
    if (page > currentPage) {
      onForward === null || onForward === void 0 || onForward(page);
    }
    if (page < currentPage) {
      onBack === null || onBack === void 0 || onBack(page);
    }
    scrollToTop && scrollTop();
  };
  const changeButtonsOnlyPage = direction => {
    if (direction === "forward") {
      onForward === null || onForward === void 0 || onForward(undefined);
    }
    if (direction === "back") {
      onBack === null || onBack === void 0 || onBack(undefined);
    }
    scrollToTop && scrollTop();
  };
  return /*#__PURE__*/_react.default.createElement("nav", _extends({
    className: "p-pagination",
    "aria-label": "Pagination"
  }, navProps), /*#__PURE__*/_react.default.createElement("ol", {
    className: (0, _classnames.default)("p-pagination__items", {
      "u-align--center": centered
    })
  }, /*#__PURE__*/_react.default.createElement(_PaginationButton.default, {
    key: "back",
    direction: "back",
    disabled: backDisabled || currentPage === 1,
    onClick: () => isNumberedPagination ? changeNumberedPage(currentPage - 1) : changeButtonsOnlyPage("back"),
    showLabel: showLabels,
    label: backLabel
  }), isNumberedPagination && !hideNumbers ? generatePaginationItems(pageNumbers, currentPage, truncateThreshold, changeNumberedPage) : null, /*#__PURE__*/_react.default.createElement(_PaginationButton.default, {
    key: "forward",
    direction: "forward",
    disabled: forwardDisabled || currentPage === pageNumbers.length,
    onClick: () => isNumberedPagination ? changeNumberedPage(currentPage + 1) : changeButtonsOnlyPage("forward"),
    showLabel: showLabels,
    label: forwardLabel
  })));
};
var _default = exports.default = Pagination;